{
  "executeOption": {
    "title": "Исполнение опциона",
    "sharesPerContract": "х 100 акций",
    "pcs": "шт",
    "quantity": "Количество",
    "side": {
      "buy": "Купить",
      "sell": "Продать"
    },
    "option": "Опцион",
    "strikePrice": "Страйк цена, $",
    "sum": "Сумма",
    "stocks": "Акций",
    "executeOption": "Исполнить опцион",
    "availableMoney": "Доступные средства",
    "optionExecuted": "Опцион успешно исполнен",
    "optionСouldNotBeExecuted": "Не удалось исполнить опцион"
  }
}
